/* --------------------------------------------------------------------------------------
   xwSegmented.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwSegmented {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {
      onSelect: '&'
    }
  }
  link(scope, elem, attrs) {
    var options = {
      width: attrs.width,
      height: attrs.height,
      theme: attrs.theme,
      type: attrs.type,
      scroll: attrs.scroll,
      customClass: attrs.customClass,
      select: (event, ui) => {
        scope.onSelect({item: ui.item})
        // Workaround to prevent multiple selected items when inside a popover
        // Can be enhanced with a logic to save last selected item and keep it highlighted
        if (attrs.hasOwnProperty('isPopover'))
          $('.ui-state-selected').removeClass('ui-state-selected')
      }
    }
    options.width = attrs.width
    options.theme = attrs.theme
    setTimeout(() => {elem.first().xrxsegmentedcontrol(options)}, 50)

    elem.on('$destroy', () => {
      elem.first().xrxsegmentedcontrol('destroy')
      elem = null
    })
  }
  static directiveFactory() {
    xwSegmented.instance = new xwSegmented()
    return xwSegmented.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwSegmented.directive.js